<template>
  <dict-select-with-add
    dict-type="MATERIAL_UNIT"
    value-field="dictLabel"
    add-text="添加单位"
    label-placeholder="如：米、平方米"
    :value="value"
    :clearable="clearable"
    :placeholder="placeholder"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
import DictSelectWithAdd from './DictSelectWithAdd.vue'

export default {
  name: 'UnitSelectWithAdd',
  components: { DictSelectWithAdd },
  props: {
    value: { type: String, default: '' },
    clearable: { type: Boolean, default: false },
    placeholder: { type: String, default: '请选择单位' },
    disabled: { type: Boolean, default: false }
  }
}
</script>
